module.exports = __webpack_public_path__ + "static/media/terms-of-use.d4cc9a8b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/terms-of-use.pdf
// module id = 1514
// module chunks = 0